import markupHelper from './markup-helper';

const parse = {
  BasicData(raw) {
    return {
      id: raw.id,
      uid: raw.uid || raw.id,
    };
  },
  TextData(raw) {
    return {
      title: raw.title,
      description: markupHelper.stripTags(raw.description_short || raw.description_long),
    };
  },
  MediaData(raw) {
    return {
      photo_url: raw.photo_medium_url,
    };
  },
  VideoData(raw) {
    return {
      url: '/video/' + raw.friendly_url + '/' + raw.uid,
      duration: raw.duration,
      featured: raw.featured,
      ...(
        raw.rating
          ? {
            likes: raw.rating.total_likes >= 1000
              ? Math.round(raw.rating.total_likes/1000.0) + 'k'
              : raw.rating.total_likes,
          }
          : {
            likes: 0,
          }
      ),
    };
  },
  FooterData(raw) {
    return {
      tags: [
        ...raw.genres.split(',').map(name => ({
          name,
          url: `/genre/${name}`,
        })),
        ...raw.topics.split(',').map(name => ({
          name,
          url: `/topic/${name}`,
        })),
      ],
    };
  },
  ChannelData(raw) {
    return {
      url: '/channel/' + raw.channel_url,
    };
  },
  CarouselData(raw) {
    return {
      title: raw.title,
      not_film: raw.not_film,
      description: raw.description,
      photo_url: raw.photo_large_url,
      url: raw.action_url,
      hide_button: raw.hide_button,
      dark_mode: raw.dark_mode,
    };
  },
};

const get = {
  CarouselData(raw) {
    return {
      ...parse.BasicData(raw),
      ...parse.CarouselData(raw),
    };
  },
  ImageData(raw) {
    return {
      ...parse.BasicData(raw),
      ...parse.TextData(raw),
      ...parse.MediaData(raw),
    };
  },
  ChannelData(raw) {
    return {
      ...parse.BasicData(raw),
      ...parse.TextData(raw),
      ...parse.MediaData(raw),
      ...parse.ChannelData(raw),
    };
  },
  VideoData(raw) {
    // Handle case for video unavailable
    if (raw.is_unavailable) {
      return {
        is_unavailable: true,
        ...parse.BasicData(raw),
      };
    }

    return {
      ...parse.BasicData(raw),
      ...parse.TextData(raw),
      ...parse.MediaData(raw),
      ...parse.VideoData(raw),
      ...parse.FooterData(raw),
    };
  },
};

const processArray = (items, fn) => items.map(item => fn(item));

export default {
  get,
  processArray,
};
